<template>
  <div>
    <v-form ref="form" v-model="valid" @submit.prevent="save">
      <v-card class="flexcard">
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md v-if="localUser">
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  label="Nom"
                  v-model.trim="$v.localUser.name.$model"
                  :error-messages="$v.localUser.name.$error ? 'Obligatoire' : []"
                  @blur="$v.localUser.name.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  label="Email"
                  v-model.trim="$v.localUser.email.$model"
                  :error-messages="$v.localUser.email.$error ? 'Email' : []"
                  @blur="$v.localUser.email.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-select
                  label="Rôle:"
                  v-model="localUser.roles"
                  :items="localUser.possibleRoles"
                  required
                  :rules="[(v) => v.length > 0 || 'Obligatoire']"
                  multiple
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.native="close">Annuler</v-btn>
          <v-btn :disabled="isDisabled" color="blue darken-1" text type="submit">Sauvegarder</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { cloneDeep } from "lodash"
import { required, email, minLength } from "vuelidate/lib/validators"

export default {
  props: {
    user: {
      required: true,
    },
    formTitle: {
      type: String,
      default: "Modifier",
    },
    isErrored: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.localUser = cloneDeep(this.user)
  },
  data() {
    return {
      valid: false,
      localUser: null,
      loading: false,
    }
  },
  computed: {
    isDisabled() {
      return !this.valid
    },
  },
  methods: {
    save() {
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }
      this.loading = true
      this.$emit("save", this.localUser)
    },
    close() {
      {
        this.$emit("cancel")
      }
    },
  },
  validations: {
    localUser: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      roles: {
        minLength: minLength(1),
      },
    },
  },
}
</script>
<style scoped>
.flexcard {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
